// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UXp9","footer":"styles_footer__2vZ9A"};